
document.addEventListener('DOMContentLoaded', function() {  
  const mainNav = document.querySelector('.nav-main');
  const searchForm = document.querySelector('.search-form');

  window.addEventListener('resize', () => {
    if(window.innerWidth > 991 ) {
      mainNav.classList.remove('opened');
      document.querySelectorAll('.menu-item-has-children').forEach(item => {
        item.classList.remove('opened');
      });
    }
  });

  document.addEventListener('click', function(e) {
    if(e.target.classList.contains('js-mobile-menu-toggler')) {
      e.target.classList.toggle('opened')
      mainNav.classList.toggle('opened');
      searchForm && searchForm.classList.remove('opened');
      document.body.classList.toggle('no-scroll');

    }

    if(e.target.classList.contains('js-search-toggler')) {
      searchForm && searchForm.classList.toggle('opened');
      mainNav.classList.remove('opened');
    }

    if (e.target.classList.contains('js-terms-show-more')) {
      const button = e.target;
      button.classList.toggle('opened');
      const termsFull =button.nextElementSibling;
      const moreText = button.dataset.more;
      const lessText = button.dataset.less;
      const isOpened = termsFull.classList.toggle('visible');
      button.textContent = isOpened ? lessText : moreText;
    }

    if (e.target.classList.contains('js-copy-casino-code')) {
      const code = e.target.closest('.toplist__content-cta-code').querySelector('.code').textContent;
      const text = e.target.closest('.toplist__content-cta-code').querySelector('.text');

      if (navigator.clipboard && code) {
        navigator.clipboard.writeText(code)
        .then(() => {
          text.textContent = 'Copied!';
        })
        .catch(err => {
          console.error('Error copying text: ', err);
        });
      }
    }
  });

  document.querySelectorAll('.js-mobile-accordion-toggler').forEach(toggler => {
    toggler.addEventListener('click', function () {
      const submenu = toggler.nextElementSibling;
      const item = toggler.closest('.menu-item');
      toggler.textContent = toggler.textContent === '+' ? '–' : '+';

      if (!submenu) return;

      item.classList.toggle('opened');
    });
  });
});

function setDynamicPadding() {
  const header = document.querySelector('header'); 
  const mainContent = document.body; 

  if (header && mainContent) {
    const headerHeight = header.offsetHeight;
    mainContent.style.paddingTop = `${headerHeight}px`;
  }
}

window.addEventListener('load', setDynamicPadding);
window.addEventListener('resize', setDynamicPadding);